// This data will be replaced with backend data in the future
export const slideData = [
	{
		// Absolute sale
		id: 1,
		image: 'https://d382afbroc2qdt.cloudfront.net/image_4.png',
		title: null,
	},
	{
		// Predictive pricing
		id: 2,
		image: 'https://blc-webapp.s3.amazonaws.com/landing/predictive-pricing.png',
		title: null,
	},
	{
		// Engine audio
		id: 3,
		image: 'https://d382afbroc2qdt.cloudfront.net/01-Audio+Boost.webp',
		title: 'AI-analyzed engine recordings',
		description:
			'Now on every dealer vehicle: high-quality engine recordings with AI-generated highlights flagging potential issues — plus sample "normal" recordings for over 95% of vehicles if an issue is detected.',
		highlightedText: 'Hear the OPENLANE difference.',
	},
	{
		// Testimonial
		id: 4,
		image: 'https://d382afbroc2qdt.cloudfront.net/03-Testimonial%20-%20Cloninger%20Ford-Toyota.png',
		title: null,
	},
	// Temporarily commenting out until this slide is needed again.
	// {
	// 	// Damage detection
	// 	id: 4,
	// 	image: 'https://d382afbroc2qdt.cloudfront.net/04-Visual%20Boost%20AI.png',
	// 	title: 'AI-assisted damage detection',
	// 	description: 'AI-detected potential exterior damage — all confirmed by experienced inspectors.',
	// 	highlightedText: 'Make faster and more informed decisions.',
	// },
	{
		// Inventory
		id: 5,
		image: 'https://d382afbroc2qdt.cloudfront.net/05-All%20the%20Inventory.webp',
		title: 'All the cars your customers crave',
		description:
			'Find thousands of vehicles at every age, condition and price point — from fresh dealer trades to exclusive first-access to off-lease vehicles.',
	},
];
